import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";

export default function OptimisationTriggerTable({
  carColour,
}: {
  carColour: string;
}) {
  const optimisationTrigger = useSelector(
    (state: RootState) => state.raceData[carColour]?.optimisationTrigger,
    isEqual,
  );

  console.log(optimisationTrigger);

  return (
    <div className={styles.container}>
      <table>
        <tbody>
          <tr>
            <th>User</th>
            <td>{optimisationTrigger?.user ?? "-"}</td>
          </tr>
          <tr>
            <th>Command</th>
            <td>{optimisationTrigger?.command ?? "-"}</td>
          </tr>
          <tr>
            <th>Time</th>
            <td>
              {optimisationTrigger
                ? new Date(optimisationTrigger.timestamp).toLocaleTimeString()
                : "-"}
            </td>
          </tr>
          <tr>
            <th>Run Time</th>
            <td>{optimisationTrigger?.runTime ?? "-"}</td>
          </tr>
          <tr>
            <th>Iterations</th>
            <td>{optimisationTrigger?.iterations ?? "-"}</td>
          </tr>
          <tr>
            <th>dValue</th>
            <td>
              {optimisationTrigger?.dValue != null
                ? optimisationTrigger.dValue.toFixed(3)
                : "-"}
            </td>
          </tr>
          <tr>
            <th>Linear</th>
            <td>
              {optimisationTrigger?.linear != null
                ? optimisationTrigger.linear
                  ? "Yes"
                  : "No"
                : "-"}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
